var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import Errors from "../shared/errors";
import Busy from "../shared/busy";
import Checkbox from "../../src/View/UI/Form/Checkbox";
import DeprecatedSelect from "../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
import ErrorService from "../../src/Services/Shared/Error.service";
import { getXSRF } from "../../src/Services/Shared/FetchService";
// @ts-expect-error - TS7034 - Variable 'comparatorOptions' implicitly has type 'any[]' in some locations where its type cannot be determined.
const comparatorOptions = [];
for (let i = 1; i <= 25; i += 1) {
    comparatorOptions.push(i);
}
// @ts-expect-error - TS7034 - Variable 'absenceOptions' implicitly has type 'any[]' in some locations where its type cannot be determined.
const absenceOptions = [];
for (let i = 1; i <= 25; i += 1) {
    absenceOptions.push(i);
}
export default class AlertRuleAdd extends PureComponent {
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        this.state = {
            selectedPropertyId: null,
            selectedOperatorId: null,
            selectedComparator: null,
            selectedResult: null,
            selectedPropertyName: null,
            selectedOperatorName: null,
            errors: [],
            isSaving: false,
            saved: false,
            validationErrors: [],
            excusedAbsencesAsAbsences: false,
        };
        this.onEvent = this.onEvent.bind(this);
        this.onPropertyChange = this.onPropertyChange.bind(this);
        this.onOperatorChange = this.onOperatorChange.bind(this);
        this.onComparatorChange = this.onComparatorChange.bind(this);
        this.onResultChange = this.onResultChange.bind(this);
        this.save = this.save.bind(this);
        this.onClose = this.onClose.bind(this);
    }
    onEvent(eventData) {
        console.log("event published", eventData);
    }
    fetchProperties() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch("/aviso/alertRule/listProperties", {
                credentials: "include",
            });
            const responseJson = yield response.json();
            return { options: responseJson.data };
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'selectedProperty' implicitly has an 'any' type.
    onPropertyChange(selectedProperty) {
        if (selectedProperty) {
            this.setState({ selectedPropertyId: selectedProperty.id });
            this.setState({ selectedPropertyName: selectedProperty.displayName });
        }
        else {
            this.setState({ selectedPropertyId: null });
            this.setState({ selectedPropertyName: null });
        }
    }
    fetchOperators() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch("/aviso/alertRule/listOperators", {
                credentials: "include",
            });
            const responseJson = yield response.json();
            return { options: responseJson.data };
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'selectedOperator' implicitly has an 'any' type.
    onOperatorChange(selectedOperator) {
        if (selectedOperator) {
            this.setState({ selectedOperatorId: selectedOperator.id });
            this.setState({ selectedOperatorName: selectedOperator.name });
        }
        else {
            this.setState({ selectedOperatorId: null });
            this.setState({ selectedOperatorName: null });
        }
    }
    // @ts-expect-error - TS7006 - Parameter 'selectedComparator' implicitly has an 'any' type.
    onComparatorChange(selectedComparator) {
        if (selectedComparator) {
            this.setState({ selectedComparator });
        }
        else {
            this.setState({ selectedComparator: null });
        }
    }
    // @ts-expect-error - TS7006 - Parameter 'selectedResult' implicitly has an 'any' type.
    onResultChange(selectedResult) {
        if (selectedResult) {
            this.setState({ selectedResult });
        }
        else {
            this.setState({ selectedResult: null });
        }
    }
    onError(message) {
        this.setState({ errors: [...this.state.errors, message] });
    }
    validateForm() {
        const validationErrors = [];
        if (!this.state.selectedPropertyId) {
            validationErrors.push("Property is required.");
        }
        if (!this.state.selectedOperatorId) {
            validationErrors.push("Operator is required.");
        }
        if (!this.state.selectedComparator) {
            validationErrors.push("Comparator is required.");
        }
        if (!this.state.selectedResult) {
            validationErrors.push("Number of Result is required.");
        }
        return validationErrors;
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const validationErrors = this.validateForm();
                this.setState({ validationErrors });
                if (validationErrors && validationErrors.length) {
                    return;
                }
                this.setState({ isSaving: true });
                const response = yield fetch("/aviso/alertRule/create", {
                    credentials: "include",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-XSRF-TOKEN": getXSRF(),
                    },
                    body: JSON.stringify({
                        alertId: this.props.alertId,
                        propertyId: this.state.selectedPropertyId,
                        operatorId: this.state.selectedOperatorId,
                        // @ts-expect-error - TS2531 - Object is possibly 'null'.
                        comparator: this.state.selectedComparator.value,
                        // @ts-expect-error - TS2531 - Object is possibly 'null'.
                        result: this.state.selectedResult.value,
                        excusedAbsencesAsAbsences: this.state.excusedAbsencesAsAbsences,
                    }),
                });
                const responseJson = yield response.json();
                if (responseJson.success) {
                    // Call the onSave function on the props.
                    if (this.props.onSave) {
                        this.props.onSave();
                    }
                    // Clear the fields on the form.
                    this.setState({
                        selectedPropertyId: null,
                        selectedPropertyName: null,
                        selectedOperatorId: null,
                        selectedOperatorName: null,
                        selectedComparator: null,
                        selectedResult: null,
                        saved: true,
                        excusedAbsencesAsAbsences: false,
                    });
                }
                else {
                    this.onError(responseJson.message);
                }
            }
            catch (e) {
                this.onError(ErrorService.getMessageFromError(e));
            }
            finally {
                this.setState({ isSaving: false });
            }
        });
    }
    onClose() {
        this.setState({ saved: false });
    }
    renderValidationErrors() {
        if (!this.state.validationErrors || !this.state.validationErrors.length) {
            return null;
        }
        return (_jsxs("div", { className: "alert alert-warning", children: [_jsx("div", { children: "Please correct the following problems:" }), _jsx("ul", { children: this.state.validationErrors.map((message, index) => (_jsx("li", { children: message }, index))) })] }));
    }
    renderPreview() {
        let property;
        let operator;
        let comparator;
        let result;
        if (this.state.selectedPropertyName === null) {
            property = "{Property}";
        }
        else {
            property = this.state.selectedPropertyName;
        }
        if (this.state.selectedOperatorName === null) {
            operator = "{Operator}";
        }
        else {
            operator = this.state.selectedOperatorName;
        }
        if (this.state.selectedComparator == null) {
            comparator = "{Value}";
        }
        else {
            // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'never'.
            comparator = this.state.selectedComparator.value.toString();
        }
        if (this.state.selectedResult == null) {
            result = "{Absences}";
        }
        else {
            // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'never'.
            result = this.state.selectedResult.value.toString();
        }
        return (_jsxs("div", { className: "alert alert-secondary", children: [_jsx("div", { children: "Preview:" }), "For courses where", _jsxs("b", { children: [" ", property] }), operator !== "Equals" ? " is " : "", _jsxs("i", { children: [" ", operator] }), _jsxs("b", { children: [" ", comparator] }), ", create an alert after a student has", _jsxs("b", { children: [" ", result, " "] }), result === "1" ? " absence" : " absences", this.state.excusedAbsencesAsAbsences && ", including excused absences", "."] }));
    }
    render() {
        return (_jsx("div", { id: "newRuleModal", className: "modal fade", role: "dialog", children: _jsx("div", { className: "modal-dialog", role: "document", children: _jsxs("div", { className: "modal-content", children: [_jsxs("div", { className: "modal-header", children: [_jsx("h4", { className: "modal-title", children: _jsx("span", { className: "js-email-preview-title", children: "New Alert Rule" }) }), _jsx("button", { type: "button", className: "close", "data-dismiss": "modal", "aria-label": "Close", onClick: this.onClose, children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) })] }), !this.state.saved ? (_jsxs("div", { className: "modal-body", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "numberOfAbsences", children: "Number of Absences" }), _jsx(DeprecatedSelect, { id: "numberOfAbsences", "aria-label": "Number of Absences", placeholder: "Select a Result", value: this.state.selectedResult, onChange: this.onResultChange, 
                                            // @ts-expect-error - TS7005 - Variable 'absenceOptions' implicitly has an 'any[]' type.
                                            options: absenceOptions.map((i) => ({
                                                label: i,
                                                value: i,
                                            })) })] }), _jsx("div", { className: "form-group", children: _jsx(Checkbox, { label: "Consider Excused Absences as Absences", checked: this.state.excusedAbsencesAsAbsences, onChange: (e) => {
                                            this.setState({
                                                excusedAbsencesAsAbsences: e.target.checked,
                                            });
                                        } }) }), _jsx("div", { className: "form-group", children: _jsx("strong", { children: "Course Filter:" }) }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "alertRuleProperty", children: "Property" }), _jsx(DeprecatedSelect.Async, { id: "alertRuleProperty", "aria-label": "Property", placeholder: "Select a Property", loadOptions: this.fetchProperties, valueKey: "id", labelKey: "displayName", value: this.state.selectedPropertyId, onChange: this.onPropertyChange })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "alertRuleOperator", children: "Operator" }), _jsx(DeprecatedSelect.Async, { id: "alertRuleOperator", "aria-label": "Operator", placeholder: "Select an Operator", loadOptions: this.fetchOperators, valueKey: "id", labelKey: "name", value: this.state.selectedOperatorId, onChange: this.onOperatorChange })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "alertRuleValue", children: "Value" }), _jsx(DeprecatedSelect, { id: "alertRuleValue", placeholder: "Select a Comparator", value: this.state.selectedComparator, onChange: this.onComparatorChange, 
                                            // @ts-expect-error - TS7005 - Variable 'comparatorOptions' implicitly has an 'any[]' type.
                                            options: comparatorOptions.map((i) => ({
                                                label: i,
                                                value: i,
                                            })) })] }), this.renderPreview(), this.renderValidationErrors(), _jsx(Errors, { errors: this.state.errors })] })) : (_jsx("div", { className: "modal-body", children: "Saved Successfully" })), _jsxs("div", { className: "modal-footer", children: [!this.state.saved ? (_jsxs("button", { type: "button", className: "btn btn-primary", onClick: this.save, disabled: this.state.isSaving, children: [this.state.isSaving ? (_jsx(Busy, {})) : (_jsx("span", { className: "fa fa-plus", "aria-hidden": "true" })), " ", "Add"] })) : (""), _jsxs("button", { type: "button", className: "btn btn-outline-secondary", "data-dismiss": "modal", onClick: this.onClose, children: [_jsx("span", { className: "fa fa-times", "aria-hidden": "true" }), " Close"] })] })] }) }) }));
    }
}
